<template>
  <footer class="site-footer">
    <div class="footer-widgets">
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-5">
            <div class="foot-about">
              <h2>
                <a class="foot-logo" href="#"><img src="@/assets/images/foot-logo.png" alt="" /></a>
              </h2>
            </div>
          </div>
          <div class="col-12 col-md-6 col-lg-3 mt-5 mt-md-0">
            <h2></h2>
            <ul>
              <li>
                <a href="https://pdpa.tsu.ac.th/" target="_blank">นโยบายความเป็นส่วนตัว</a>
              </li>
            </ul>
          </div>

          <div class="col-12 col-md-6 col-lg-3 mt-5 mt-md-0">
            <div class="foot-contact">
              <h2>ติดต่อสอบถาม</h2>
              <ul>
                <li>
                  <font-awesome-icon :icon="['fas', 'phone']" />
                  <span>0-7431-7600</span>
                </li>
                <li>
                  <font-awesome-icon :icon="['fas', 'location-dot']" />
                  <span>140 ถ.กาญจนวนิช ม.4 ต.เขารูปช้าง อ.เมือง จ.สงขลา 90000</span>
                </li>
                <li>
                  <font-awesome-icon :icon="['fas', 'location-dot']" />
                  <span>222 หมู่ 2 ต.บ้านพร้าว อ.ป่าพะยอม จ.พัทลุง 93210</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="m-0">
              Copyright &copy;{{ currYear }} All rights reserved | by
              <a href="https://lrdt.tsu.ac.th/" target="_blank"
                >Institute of Learning Resources and Digital Technology</a
              >
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
const currYear = new Date().getFullYear();
</script>

<style></style>